import { render, staticRenderFns } from "./SeniorChoose.vue?vue&type=template&id=c8df9b9c&scoped=true"
import script from "./SeniorChoose.vue?vue&type=script&lang=js"
export * from "./SeniorChoose.vue?vue&type=script&lang=js"
import style0 from "./SeniorChoose.vue?vue&type=style&index=0&id=c8df9b9c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8df9b9c",
  null
  
)

export default component.exports